<template>
  <div>
    <z-header :title="title" :actions="actions"></z-header>

    <section>
      <form @submit.prevent="validateBeforeSubmit">
        <b-field
          label="CNPJ"
          expanded
          :type="{ 'is-danger': errors.has('document') }"
          :message="errors.first('document')"
          size="is-large"
          v-cleave="masks.CNPJ"
          @input.native="cleaveRefresh"
        >
          <b-input
            v-model="data.document"
            name="document"
            maxlength="18"
            :has-counter="false"
            v-validate="'required|document'"
            data-vv-as="document"
            disabled
          />
        </b-field>

        <b-field
          label="Nome da empresa*"
          expanded
          :type="{ 'is-danger': errors.has('name') }"
          :message="errors.first('name')"
          size="is-large"
        >
          <b-input
            v-model="data.name"
            name="name"
            maxlength="50"
            :has-counter="false"
            v-validate="'required'"
            data-vv-as="nome da empresa"
          />
        </b-field>

        <!-- street: "",
                zipCode: null,
                city: "",
                state: "" -->

        <hr />
        <b-field grouped>
          <b-field
            label="Endereço*"
            expanded
            :type="{ 'is-danger': errors.has('street') }"
            :message="errors.first('street')"
            size="is-large"
          >
            <b-input
              v-model="data.address.street"
              name="street"
              v-validate="'required'"
              data-vv-as="endereço"
              maxlength="255"
              :has-counter="false"
            />
          </b-field>
          <b-field
            label="Número*"
            :type="{ 'is-danger': errors.has('number') }"
            :message="errors.first('number')"
            size="is-large"
          >
            <b-input
              v-model="data.address.number"
              name="number"
              maxlength="48"
              :has-counter="false"
              v-validate="'required'"
              data-vv-as="número"
            />
          </b-field>
        </b-field>
        <b-field grouped>
          <b-field
            label="Complemento"
            expanded
            :type="{ 'is-danger': errors.has('complement') }"
            :message="errors.first('complement')"
            size="is-large"
          >
            <b-input
              v-model="data.address.complement"
              name="complement"
              maxlength="255"
              :has-counter="false"
            />
          </b-field>
          <b-field
            label="Bairro*"
            expanded
            :type="{ 'is-danger': errors.has('district') }"
            :message="errors.first('district')"
            size="is-large"
          >
            <b-input
              v-model="data.address.district"
              name="district"
              maxlength="255"
              :has-counter="false"
              v-validate="'required'"
              data-vv-as="bairro"
            />
          </b-field>
        </b-field>
        <b-field grouped>
          <b-field
            label="CEP*"
            expanded
            :type="{ 'is-danger': errors.has('zipCode') }"
            :message="errors.first('zipCode')"
            size="is-large"
          >
            <b-input
              v-model="data.address.zipCode"
              name="zipCode"
              v-validate="'required'"
              data-vv-as="CEP"
              v-cleave="masks.zipcode"
              @input.native="cleaveRefresh"
            />
          </b-field>
          <b-field
            label="Cidade*"
            expanded
            :type="{ 'is-danger': errors.has('city') }"
            :message="errors.first('city')"
            size="is-large"
          >
            <b-input
              v-model="data.address.city"
              name="city"
              maxlength="255"
              :has-counter="false"
              v-validate="'required'"
              data-vv-as="cidade"
            />
          </b-field>

          <b-field
            label="Estado*"
            expanded
            :type="{ 'is-danger': errors.has('state') }"
            :message="errors.first('state')"
            size="is-large"
          >
            <b-select
              placeholder="Selecione um estado"
              expanded
              v-model="data.address.state"
              v-validate="'required'"
              name="state"
              data-vv-as="estado"
            >
              <option
                v-for="option in states"
                :value="option.id"
                :key="option.id"
              >
                {{ option.title }}
              </option>
            </b-select>
          </b-field>
        </b-field>

        <hr />
        <div class="buttons is-right">
          <button
            class="button is-rounded is-primary"
            type="submit"
            @click.prevent="validateAndSubmit"
          >
            Salvar
          </button>
        </div>
      </form>
    </section>
    <hr />
    <section>
      <Restrictions />
    </section>
  </div>
</template>

<script>
import ZHeader from "../../layout/Header";
import { formatCNPJ } from "../../filters/document";
import cleave, { cleaveRefresh, masks } from "../../directives/cleave.js";
import company from "../../services/company";
import Restrictions from "../restrictions/List";

export default {
  data() {
    return {
      title: "Configurações",
      actions: [],
      data: {
        address: {},
      },
      isLoading: false,
      masks,
      cleaveRefresh,
      states: [
        { id: "AC", title: "Acre" },
        { id: "AL", title: "Alagoas" },
        { id: "AP", title: "Amapá" },
        { id: "AM", title: "Amazonas" },
        { id: "BA", title: "Bahia" },
        { id: "CE", title: "Ceará" },
        { id: "DF", title: "Distrito Federal" },
        { id: "ES", title: "Espírito Santo" },
        { id: "GO", title: "Goiás" },
        { id: "MA", title: "Maranhão" },
        { id: "MT", title: "Mato Grosso" },
        { id: "MS", title: "Mato Grosso do Sul" },
        { id: "MG", title: "Minas Gerais" },
        { id: "PA", title: "Pará" },
        { id: "PB", title: "Paraíba" },
        { id: "PR", title: "Paraná" },
        { id: "PE", title: "Pernambuco" },
        { id: "PI", title: "Piauí" },
        { id: "RJ", title: "Rio de Janeiro" },
        { id: "RN", title: "Rio Grande do Norte" },
        { id: "RS", title: "Rio Grande do Sul" },
        { id: "RO", title: "Rondônia" },
        { id: "RR", title: "Roraima" },
        { id: "SC", title: "Santa Catarina" },
        { id: "SP", title: "São Paulo" },
        { id: "SE", title: "Sergipe" },
        { id: "TO", title: "Tocantins" },
      ],
    };
  },
  directives: {
    cleave,
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.isLoading = true;

      try {
        const myCompany = await company.get();
        this.data = Object.assign({ address: {} }, myCompany);
        this.data.document = formatCNPJ(this.data.document);

        const address = await company.getAddress();
        this.data = Object.assign(this.data, { address });
      } catch (err) {
        if (
          err.config &&
          err.config.url &&
          err.config.url.match(/\/user\/address/gi)
        ) {
          const { response } = err;

          switch (response.status) {
            case 406:
              // user has no address for this city
              this.address = {
                street: "",
                complement: "",
                number: null,
                district: "",
                zipCode: null,
                city: "",
                state: "",
              };
              return;
          }
        }
        this.$buefy.toast.open({
          message: "Erro ao carregar as configurações",
          type: "is-danger",
        });
      }

      this.isLoading = false;
    },
    getRawData() {
      const rawData = {
        name: this.data.name,
        address: this.data.address,
      };

      return rawData;
    },
    validateAndSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.save(this.getRawData());
          return;
        }
        this.$buefy.toast.open({
          message: "Verfique os campos marcados para continuar",
          type: "is-danger",
        });
      });
    },
    async save(rawData) {
      try {
        const { address: addressData, ...companyData } = rawData;

        this.isLoading = true;
        await company.update(companyData);
        await company.updateAddress(addressData);

        this.$buefy.toast.open({
          message: "As configurações da empresa foram atualizadas",
          type: "is-success",
        });
      } catch (err) {
        console.error(err);

        this.$buefy.toast.open({
          message: "Erro ao atualizar as configurações",
          type: "is-danger",
        });
      }
    },
  },
  components: {
    ZHeader,
    Restrictions,
  },
};
</script>

<style lang="scss"></style>
